import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=14fd9874&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd9874",
  null
  
)

export default component.exports